import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {push} from 'react-router-redux';
import update from 'react-addons-update';
import _Textarea from 'react-textarea-autosize';

import * as styles from '../../styles';
import Tree from '../tree';
import {request} from '../../containers/actions';
import {component as Users} from '../users';
import {setSelection} from '../../paginator/actions';
import Dialog from '../../dialog/dialog';
import {setUnreadMessages} from '../../containers/actions';

const Textarea = new Radium(_Textarea);


//@Radium
export default class Message extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static replyTo = undefined

    initialState = {
        data: {
            root: undefined,
            sender: {},
            recipients: [],
            attachments: {files: []},
            subject: '',
            body: '',
        },
        replyTo: undefined,
        recipient: '',
        users: [],
        recipientsScroll: 0,
    }

    state = _.cloneDeep(this.initialState)

    usersButtonActions = [
        {
            label: window.gettext('Back'),
            default: true,
            action: () => this.setState({selectRecipients: false}),
        },
        {
            label: window.gettext('Choose'),
            default: true,
            style: {backgroundColor: styles.fourthColor},
            action: () => this.setState(update(this.state, {
                selectRecipients: {$set: false},
                data: {recipients: {$set: this.props.store.getIn(['users', 'selected']).map(recipient => recipient.toJS()).toArray()}},
            })),
        },
    ]

    componentDidMount() {
        this.fetch(this.props.params.id);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.id !== this.props.params.id)
            this.fetch(nextProps.params.id);
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedRecipient !== this.state.selectedRecipient && this.state.selectedRecipient !== undefined) {
            this.refs.recipientsInput.focus();
            this.losingFocus = true;
            this.refs['recipient-' + this.state.data.recipients[this.state.selectedRecipient].id].scrollIntoView();
        }
    }

    async fetch(id) {
        this.setState(this.initialState);
        if (id === 'compose') {
            this.setState(update(this.state, {
                replyTo: {$set: Message.replyTo},
                data: {
                    subject: {
                        $set: Message.replyTo
                            ? Message.replyTo.subject.startsWith(window.gettext('Reply') + ': ')
                                ? Message.replyTo.subject
                                : window.gettext('Reply') + ': ' + Message.replyTo.subject
                            : '',
                    },
                    sender: {$set: this.context.user},
                    recipients: {$push: Message.replyTo ? [Message.replyTo.sender] : []},
                },
            }));
            Message.replyTo = undefined;
            return;
        }
        const response = await this.context.store.dispatch(request({
            path: `/message/${id}/`,
        }));
        if (this.props.params.id === id) {
            this.setState({data: response}, async () => {
                if (!this.state.data.read && _.some(this.state.data.recipients, recipient => recipient.id === this.context.user.id)) {
                    const response = await this.context.store.dispatch(request({
                        path: `/message/${id}/`,
                        body: {read: true},
                        method: 'PATCH',
                    }));
                    if (response.read)
                        this.context.store.dispatch(setUnreadMessages(this.context.store.getState().getIn(['application', 'unreadMessages']) - 1));
                }
            });
        }
    }

    addRecipient(user) {
        this.setState(
            {recipient: '', currentUser: undefined, users: []},
            () => {
                if (_.some(this.state.data.recipients, recipient => recipient.id === user.id))
                    return;
                this.setState(update(this.state, {data: {recipients: {$push: [user]}}}));
            },
        );
    }

    render() {
        return <div style={{fontSize: '.9em'}}>
            <button
                style={{
                    ...styles.defaultButton,
                    float: 'left',
                    marginRight: '.5em',
                }}
                onClick={() => this.props.router.goBack()}>
                {window.gettext('Back')}
            </button>
            {this.props.params.id === 'compose'
                ? <button
                    style={{
                        ...styles.defaultButton,
                        backgroundColor: styles.fourthColor,
                        float: 'left',
                        marginRight: '.5em',
                    }}
                    onClick={async () => {
                        const response = await this.context.store.dispatch(request({
                            path: '/message/',
                            body: window.toFormData({
                                ...this.state.data,
                                body: this.state.replyTo
                                    ? this.state.data.body + '\n--------------------\n' +
                                this.state.replyTo.sender.firstname + ' ' + this.state.replyTo.sender.lastname + ' - ' +
                                this.state.replyTo.timestamp.toJalali().persian('YYYY/MM/DD - hh:mm:ss') + ':\n' +
                                this.state.replyTo.body
                                    : this.state.data.body,
                                sender: {id: this.state.data.sender.id},
                                recipients: _.map(this.state.data.recipients, recipient => ({id: recipient.id})),
                                ...this.context.user.hasPerm('message.sms')
                                    ? {type: this.props.store.getIn(['typesTree', 'selected']).keySeq().first()}
                                    : {},
                            }),
                        }));
                        this.context.store.dispatch(push(this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ).split('/').slice(0, -2).join('/') + '/' + `${response.id}/`));
                    }}>
                    {window.gettext('Submit')}
                </button>
                : <button
                    style={{
                        ...styles.button,
                        float: 'left',
                        marginRight: '.5em',
                    }}
                    onClick={() => {
                        Message.replyTo = this.state.data;
                        this.context.store.dispatch(push(this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ).split('/').slice(0, -2).join('/') + '/compose/'));
                    }}>
                    {window.gettext('Reply')}
                </button>
            }
            <div style={this.props.params.id === 'compose' && !this.state.replyTo ? {paddingTop: '1em', paddingBottom: '1em'} : undefined}>
                {window.gettext('Sender')}: {`${this.state.data.sender.firstname} ${this.state.data.sender.lastname}`}
            </div>
            {this.props.params.id === 'compose'
                ? this.state.replyTo
                    ? <div style={{paddingBottom: '1em'}}>
                        {window.gettext('Recipient')}: {`${this.state.data.recipients[0].firstname} ${this.state.data.recipients[0].lastname}`}
                    </div>
                    : <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'min-content auto',
                            gridColumnGap: '.5em',
                            marginBottom: styles.field.marginBottom,
                            position: 'relative',
                        }}>
                        {window.gettext('Recipients')}:
                        <div style={{position: 'relative'}}>
                            <i
                                style={{position: 'absolute', top: '.5em', left: '.5em', zIndex: 5, cursor: 'pointer'}}
                                className='fa-list-alt'
                                onClick={() => {
                                    this.setState({selectRecipients: !this.state.selectRecipients});
                                    this.context.store.dispatch(setSelection(
                                        this.state.data.recipients,
                                        this.props.store.getIn(['users', 'paginator', 'elementId']),
                                    ));
                                }}>
                            </i>
                            <div
                                key='recipients'
                                style={{
                                    ...styles.field,
                                    height: undefined,
                                    padding: '.1em',
                                    marginBottom: undefined,
                                    padding: undefined,
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    minHeight: '2.4em',
                                    maxHeight: '8em',
                                    overflowY: 'auto',
                                    ...(Radium.getState(this.state, 'recipientsInput', ':focus') ? styles.field[':focus'] : {}),
                                }}
                                onScroll={({target}) => {
                                    this.setState({recipientsScroll: target.scrollTop});
                                    if (this.refs.recipientsInput)
                                        this.refs.recipientsInput.blur();
                                }}>
                                {_.map(
                                    this.state.data.recipients,
                                    (recipient, index) => <div
                                        key={recipient.id}
                                        ref={'recipient-' + recipient.id}
                                        style={{
                                            ...styles.tag,
                                            paddingTop: '.3em',
                                            paddingBottom: '.3em',
                                            fontSize: '.9em',
                                            display: undefined,
                                            flexGrow: '0',
                                            backgroundColor: this.state.selectedRecipient === index
                                                ? styles.alertBackColor
                                                : styles.tag.backgroundColor,
                                        }}
                                        onClick={() => this.setState({selectedRecipient: index})}>
                                        {`${recipient.firstname} ${recipient.lastname}`}
                                    </div>,
                                )}
                                <div
                                    style={{
                                        flexGrow: '1',
                                        marginLeft: '1.5em',
                                        pointerEvents: 'auto',
                                        visibility: 'visible',
                                    }}>
                                    <input
                                        key='recipientsInput-shadow'
                                        style={{
                                            ...styles.input,
                                            visibility: 'hidden',
                                            boxShadow: 'none',
                                            border: 'none',
                                            outline: 'none',
                                            width: '100%',
                                            backgroundColor: 'transparent',
                                            ':focus': {boxShadow: 'none'},
                                        }}
                                        value={this.state.recipient.persian()}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div
                                key='recipients-shadow'
                                style={{
                                    ...styles.field,
                                    visibility: 'hidden',
                                    position: 'absolute',
                                    top: `${-this.state.recipientsScroll}px`,
                                    height: undefined,
                                    maxHeight: this.state.recipientsFocused ? undefined : `calc(${this.state.recipientsScroll}px + 8em)`,
                                    pointerEvents: 'none',
                                    overflowY: this.state.recipientsFocused ? 'visible' : 'hidden',
                                    boxShadow: 'none',
                                    padding: '.1em',
                                    marginBottom: undefined,
                                    padding: undefined,
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    ':focus': undefined,
                                }}>
                                {_.map(
                                    this.state.data.recipients,
                                    recipient => <div
                                        key={recipient.id}
                                        style={{
                                            ...styles.tag,
                                            pointerEvents: 'none',
                                            paddingTop: '.3em',
                                            paddingBottom: '.3em',
                                            fontSize: '.9em',
                                            display: undefined,
                                            flexGrow: '0',
                                        }}>
                                        {`${recipient.firstname} ${recipient.lastname}`}
                                    </div>,
                                )}
                                <div
                                    style={{
                                        flexGrow: '1',
                                        marginLeft: '1.5em',
                                        pointerEvents: 'auto',
                                        visibility: 'visible',
                                    }}>
                                    <input
                                        ref='recipientsInput'
                                        style={{
                                            ...styles.input,
                                            boxShadow: 'none',
                                            border: 'none',
                                            outline: 'none',
                                            width: '100%',
                                            backgroundColor: 'transparent',
                                            ':focus': {boxShadow: 'none'},
                                        }}
                                        value={this.state.recipient.persian()}
                                        onChange={async ({target: {value}}) => {
                                            value = value.english();
                                            this.setState({recipient: value, currentUser: undefined});
                                            if (!value) {
                                                this.setState({users: []});
                                                return;
                                            }
                                            const response = await this.context.store.dispatch(request({
                                                path: `/user/?search=${value.replace(/ /g, ',')}&limit=10&id_ne=${_.map(
                                                    this.state.data.recipients,
                                                    'id',
                                                ).join(',')}`,
                                            }));
                                            if (this.refs.recipientsInput.value.english() === value)
                                                this.setState({users: response.results});
                                        }}
                                        onKeyDown={event => {
                                            const keyCode = event.keyCode;
                                            if (keyCode === 13 && this.state.currentUser !== undefined) {
                                                this.addRecipient(this.state.users[this.state.currentUser]);
                                            }
                                            if (this.state.users.length) {
                                                if (keyCode === 38) {
                                                    this.setState({currentUser: (this.state.currentUser || this.state.users.length) - 1});
                                                    event.preventDefault();
                                                }
                                                if (keyCode === 40) {
                                                    this.setState({
                                                        currentUser: this.state.currentUser === undefined
                                                            ? 0
                                                            : (this.state.currentUser + 1) % this.state.users.length,
                                                    });
                                                    event.preventDefault();
                                                }
                                            }
                                            if (keyCode === 39 && (
                                                event.target.selectionStart === 0 &&
                                            event.target.selectionEnd === 0 ||
                                            this.state.selectedRecipient !== undefined
                                            )) {
                                                this.setState({
                                                    selectedRecipient: this.state.data.recipients.length === 0
                                                        ? undefined
                                                        : this.state.selectedRecipient === undefined
                                                            ? this.state.data.recipients.length - 1
                                                            : Math.max(this.state.selectedRecipient - 1, 0),
                                                });
                                            }
                                            else if (keyCode === 37 && this.state.selectedRecipient !== undefined) {
                                                this.setState({
                                                    selectedRecipient: this.state.data.recipients.length === 0
                                                        ? undefined
                                                        : this.state.selectedRecipient < this.state.data.recipients.length - 1
                                                            ? this.state.selectedRecipient + 1
                                                            : undefined,
                                                });
                                                event.preventDefault();
                                            }
                                            else if ((keyCode === 8 || keyCode === 46) && this.state.selectedRecipient !== undefined) {
                                                if (this.state.selectedRecipient !== undefined) {
                                                    this.setState(update(this.state, {
                                                        selectedRecipient: {$set: undefined},
                                                        data: {recipients: {$splice: [[this.state.selectedRecipient, 1]]}},
                                                    }));
                                                }
                                                event.preventDefault();
                                            }
                                            else if (keyCode === 8 && event.target.selectionStart === 0 && event.target.selectionEnd === 0) {
                                                this.setState({
                                                    selectedRecipient: this.state.data.recipients.length
                                                        ? this.state.data.recipients.length - 1
                                                        : undefined,
                                                });
                                            }
                                            else {
                                                this.setState({selectedRecipient: undefined});
                                            }
                                        }}
                                        onFocus={() => this.setState({recipientsFocused: true})}
                                        onBlur={() => {
                                            this.setState({recipientsFocused: false});
                                            if (this.losingFocus) {
                                                this.losingFocus = false;
                                                this.refs.recipientsInput.focus();
                                            }
                                        }}
                                    />
                                    <div style={{position: 'relative'}}>
                                        <div
                                            style={{
                                                display: this.state.recipientsFocused
                                                    ? undefined
                                                    : 'none',
                                                position: 'absolute',
                                                backgroundColor: 'white',
                                                width: '100%',
                                                minWidth: '32em',
                                                top: '-.3em',
                                            }}>
                                            {_.map(
                                                this.state.users,
                                                (user, index) => {
                                                    const label = `${user.firstname} ${user.lastname} - ${(user.national_id || '').persian()}` +
                                                ` - ${user.username.persian()}`;
                                                    return <div
                                                        key={user.id}
                                                        style={{
                                                            border: '.0625em solid #cccccc',
                                                            cursor: 'pointer',
                                                            backgroundColor: this.state.currentUser === index ? styles.highlightColor : undefined,
                                                        }}
                                                        onMouseDown={event => event.preventDefault()}
                                                        onClick={() => this.addRecipient(user)}>
                                                        {label}
                                                    </div>;
                                                },
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.selectRecipients
                            ? <Dialog
                                isOpen
                                easyCancel={false}>
                                <div style={{minWidth: '70em'}}>
                                    <Users
                                        store={this.props.store.get('users')}
                                        readonly
                                        admin={this.props.admin}
                                        params={{}}
                                        buttonActions={this.usersButtonActions}
                                    />
                                </div>
                                {window.gettext('Select Recipients')}
                            </Dialog>
                            : null
                        }
                    </div>
                : null
            }
            {this.props.params.id === 'compose'
                ? <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'min-content auto',
                        gridColumnGap: '.5em',
                        alignItems: 'center',
                        marginBottom: styles.field.marginBottom,
                    }}>
                    {window.pgettext('message', 'Subject')}:&nbsp;
                    <input
                        key='subject'
                        style={{...styles.field, marginBottom: undefined}}
                        value={this.state.data.subject || ''}
                        onChange={({target: {value}}) => this.setState(update(this.state, {data: {subject: {$set: value.persian()}}}))}
                    />
                </div>
                : <div>
                    {window.pgettext('message', 'Subject')}: {this.state.data.subject}
                </div>
            }
            <div>
                {this.props.params.id === 'compose'
                    ? <Textarea
                        placeholder={window.gettext('Message Body')}
                        style={{
                            ...styles.field,
                            minHeight: '4em',
                            width: '100%',
                            maxWidth: '100%',
                            marginBottom: undefined,
                        }}
                        value={this.state.data.body || ''}
                        onChange={({target: {value}}) => this.setState(update(this.state, {data: {body: {$set: value.persian()}}}))}
                    />
                    : <div style={{whiteSpace: 'pre-wrap'}}>
                        <hr/>
                        {this.state.data.body}
                    </div>
                }
            </div>
            {this.state.replyTo
                ? <div style={{whiteSpace: 'pre-wrap', marginTop: '1em'}}>
                    {window.interpolate(
                        window.gettext('At %(date)s %(sender)s wrote'),
                        {
                            sender: `${this.state.replyTo.sender.firstname} ${this.state.replyTo.sender.lastname}`,
                            date: this.state.replyTo.timestamp.toJalali().persian('YYYY/MM/DD - hh:mm:ss'),
                        },
                        true,
                    )}:
                    <br/>
                    {this.state.replyTo.body}
                </div>
                : null
            }
            {this.props.params.id === 'compose'
                ? <div style={{marginTop: '.5em'}}>
                    {_.map(
                        this.state.data.attachments.files,
                        (attachment, index) => <div key={index}>
                            <i
                                className='fa-close'
                                style={{cursor: 'pointer'}}
                                onClick={() => {
                                    this.setState(update(this.state, {data: {attachments: {files: {$splice: [[index, 1]]}}}}));
                                }}>
                            </i>
                            &nbsp;
                            {attachment.name}
                        </div>,
                    )}
                    <i
                        style={{float: 'left', cursor: 'pointer'}}
                        className='fa-attachment fa-lg'
                        onClick={() => this.refs.fileSelector.click()}>
                    </i>
                    <input
                        type='file'
                        ref='fileSelector'
                        multiple
                        style={{display: 'none'}}
                        onClick={() => {
                            this.refs.fileSelector.value = '';
                        }}
                        onChange={async () => {
                            this.setState(update(this.state, {
                                data: {attachments: {files: {$push: _.map(
                                    this.refs.fileSelector.files,
                                    file => ({
                                        content: file,
                                        name: file.name,
                                        download: true,
                                    }),
                                )}}},
                            }));
                        }}
                    />
                </div>
                : <div style={{marginTop: '.5em'}}>
                    {_.map(
                        this.state.data.attachments.files,
                        (attachment, index) => <div key={index}>
                            <i
                                className='fa-download'
                                style={{cursor: 'pointer'}}
                                onClick={() => {
                                    window.location =
                                        `/file/${this.state.data.attachments.uuid}/${attachment.uuid}`;
                                }}>
                            </i>
                            &nbsp;
                            {attachment.name}
                        </div>,
                    )}
                </div>
            }
            {this.props.params.id === 'compose' && this.context.user.hasPerm('message.sms')
                ? <div style={{marginTop: '1em', width: '15em'}}>
                    <Tree
                        store={this.props.store.get('typesTree')}
                        header
                        readonly
                        multiSelection={false}
                        combobox
                        resource='message-type'
                        label={window.gettext('SMS')}
                    />
                </div>
                : null
            }
        </div>;
    }
}
